export default "__VITE_ASSET__DlDRN$A4__"